const STORAGE_KEY = "calendar_install_session_v1";

export function loadInstallSession() {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.installData || !parsed?.shop) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveInstallSession(payload) {
  if (typeof window === "undefined" || !payload?.installData || !payload?.shop) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        shop: payload.shop,
        host: payload.host || null,
        installData: payload.installData,
        savedAt: Date.now(),
      }),
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearInstallSession() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
